<template>
  <div>
    <template v-if="planningOrder">
      <!-- First Row -->
      <b-row>
        <b-col
          cols="12"
          xl="9"
          lg="8"
          md="7"
        >
          <manufacturing-info-card :planning-order="planningOrder" />
        </b-col>
        <b-col
          cols="12"
          md="5"
          xl="3"
          lg="4"
        >
          <planning-deliver-card :planning-order="planningOrder" />
        </b-col>
      </b-row>

      <b-row>
        <b-col
          cols="12"
          lg="7"
        >
          <manufacturing-management-card
            :planning-order="planningOrder"
            :user-data="userData"
          />
        </b-col>
        <b-col
          cols="12"
          lg="5"
        >
          <manufacturing-comments-card
            :planning-order="planningOrder"
            :user-data="userData"
          />
        </b-col>
      </b-row>
    </template>
    <loading-skeleton v-else/>

  </div>
</template>

<script>
import store from '@/store'
import router from '@/router'
import { ref, onUnmounted } from '@vue/composition-api'
import {
  BRow, BCol, BAlert, BLink, BSkeleton, BCard,
} from 'bootstrap-vue'
import api from '@/plugin/axios'
import ManufacturingInfoCard from './ManufacturingInfoCard.vue'
import PlanningDeliverCard from './PlanningDeliverCard.vue'
import ManufacturingCommentsCard from './ManufacturingCommentsCard.vue'
import ManufacturingManagementCard from './ManufacturingManagementCard.vue'
import LoadingSkeleton from '@/views/misc/LoadingSkeleton.vue'

export default {
  components: {
    LoadingSkeleton,
    BRow,
    BCol,
    BAlert,
    BLink,
    BSkeleton,
    BCard,

    // Local Components
    ManufacturingInfoCard,
    PlanningDeliverCard,
    ManufacturingCommentsCard,
    ManufacturingManagementCard,
  },
  data() {
    return {
      planningOrder: null,
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  async created() {
    const [response] = await Promise.all([
      api.get(`/api/manufacturing-orders/${this.$route.params.id}`),
    ])

    this.planningOrder = response.data
    console.log(this.planningOrder)
  },
}
</script>

<style>

</style>
